import React from "react";

export const DemoInstanceWatermark: React.FC<{
  demoInstance: string | null;
}> = ({ demoInstance }) => {
  if (!demoInstance || demoInstance === "") return null;

  const prNumber = demoInstance.match("\\d+");

  return (
    <div
      className="pointer-events-none fixed  inset-x-auto bottom-16 right-4
                z-[9999999999] flex select-none items-center justify-center
                text-xl font-regular text-chorus-red-500/50
                md:bottom-8 md:right-8 md:text-display-sm"
    >
      Viewing PR #{prNumber}
    </div>
  );
};
